// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { z } from "zod";

import {
  dateStringSchema,
  nullishAsUndefined,
  usArResidentCommonSchema,
} from "~datatypes";

export const usArStateDataSchema = usArResidentCommonSchema.extend({
  cohortCode: nullishAsUndefined(z.string()),
  hasApprovedCasePlan: nullishAsUndefined(z.boolean()),
  maxCpus: nullishAsUndefined(z.number()),
  isEligibleForCpus: nullishAsUndefined(z.boolean()),
  edovoHoursThisMonth: z.number(),
  edovoCarryInHours: z.number(),
  edovoHoursToNextCpu: z.number(),
  edovoIsCreditingMonth: z.boolean(),
  edovoLastRefreshedAt: nullishAsUndefined(dateStringSchema),
  edovoDataBuiltAt: nullishAsUndefined(dateStringSchema),
  lastUpdatedDate: dateStringSchema,
});
export type UsArResidentJiiData = z.output<typeof usArStateDataSchema>;
export type RawUsArResidentJiiData = z.input<typeof usArStateDataSchema>;
